import { create } from 'zustand';

type MigrateNumberStore = {
  open: boolean;
  closeModal: VoidFunction;
  openModal: VoidFunction;
};

export const useStoreMigrateModal = create<MigrateNumberStore>((set) => ({
  open: false,
  closeModal: () => set(() => ({ open: false })),
  openModal: () => set(() => ({ open: true })),
}));
